import { resolveCDNDir } from '@gjensidige/se-content-helpers';
import { apiFetcher } from '@gjensidige/service-async';

import { WidgetProps } from '../interfaces/Types';
import boyChildFamily from '../images/boyChildFamily.webp';
import boyChildFamilySmall from '../images/boyChildFamilySmall.webp';

export class AppHelper {
  static CUSTOMER_PHONE_NR_SESSION_KEY = 'customerPhoneNr';
  static phoneNumberErrorText =
    'Ange mobilnumret med 10 siffror och utan bindestreck eller mellanslag.';
  static phoneNrHelpText =
    'Vi ringer gärna upp dig och hjälper dig hitta rätt försäkring för dina behov.';

  static webshopUrl = '/links/webshop-villa-home';
  static propertyId = 'propertyId';
  static streetAddress = 'streetAddress';

  static defaultErrorTitle = 'Kontakta oss';
  static defaultErrorMessage =
    'Vi kan tyvärr inte ge dig ett pris på webben. Kontakta oss så hjälper vi dig.';
  static defaultErrorStatusCode = 580;

  static pcrNumberErrorText = 'Vänligen kontrollera personnumret';
  static pcrMinAgeErrorText =
    'Du måste vara över 18 år för att köpa en försäkring';
  static streetAddressErrorText = 'Vänligen kontrollera gatuadress';
  static municipalityErrorText = 'Vänligen kontrollera kommun';
  static propertyIdErrorText = 'Vänligen kontrollera fastighetsbeteckning';
  static zipCodeErrorText = 'Vänligen kontrollera postnumret';

  static getDefaultData = (): WidgetProps => {
    return {
      headerText: 'Se pris och köp villaförsäkring',
      cprNumberLabel: 'Ditt personnummer',
      cprNumberPlaceHolder: 'ÅÅÅÅMMDDNNNN',
      cprNumberHelpText:
        'Vi behöver ditt personnummer för att kunna ge dig rätt pris. Personnumret ger oss bland annat uppgifter om var du bor och din ålder.',
      zipCodeLabel: 'Postnummer',
      addressLabel: 'Gatuadress',
      municipalityLabel: 'Kommun',
      propertyNamePlaceholder: 'Ex. “Pålsjö 1:24”',
      propertyNameLabel: 'Fastighetsbeteckning',
      propertyNameHelpText: 'Läs mer om fastighetsbeteckning',
      calculateBtnLabel: 'Se ditt pris',
      footerMessage: '',
      personalDataHandlingInfoLinkText:
        'Läs mer om vår hantering av dina personuppgifter',
      personalDataHandlinkUrl: '/om-oss/gdpr',
      imageInfo: {
        image: boyChildFamily,
        smallScreenImage: boyChildFamilySmall,
        propertyIdExampleIllustration: 'PropertyIdExample_simple.svg',
        imageAltText: 'Barn som leker i trädgården med sin familj'
      }
    };
  };

  static prepareData = (defaultData: WidgetProps, additionalData: any) => {
    return {
      headerText: additionalData?.headerText || defaultData.headerText,
      cprNumberLabel:
        additionalData?.cprNumberLabel || defaultData.cprNumberLabel,
      cprNumberPlaceHolder:
        additionalData?.cprNumberPlaceHolder ||
        defaultData.cprNumberPlaceHolder,
      cprNumberHelpText:
        additionalData?.cprNumberHelpText || defaultData.cprNumberHelpText,
      zipCodeLabel: additionalData?.zipCodeLabel || defaultData.zipCodeLabel,
      addressLabel: additionalData?.addressLabel || defaultData.addressLabel,
      municipalityLabel:
        additionalData?.municipalityLabel || defaultData.municipalityLabel,
      propertyNamePlaceholder:
        additionalData?.propertyNamePlaceholder ||
        defaultData.propertyNamePlaceholder,
      propertyNameLabel:
        additionalData?.propertyNameLabel || defaultData.propertyNameLabel,
      propertyNameHelpText:
        additionalData?.propertyNameHelpText ||
        defaultData.propertyNameHelpText,
      calculateBtnLabel:
        additionalData?.calculateBtnLabel || defaultData.calculateBtnLabel,
      footerMessage: additionalData?.footerMessage || defaultData.footerMessage,
      personalDataHandlingInfoLinkText:
        additionalData?.personalDataHandlingInfoLinkText ||
        defaultData.personalDataHandlingInfoLinkText,
      personalDataHandlinkUrl:
        additionalData?.personalDataHandlinkUrl ||
        defaultData.personalDataHandlinkUrl,
      imageInfo: {
        image: defaultData?.imageInfo?.image,
        smallScreenImage: defaultData?.imageInfo?.smallScreenImage,
        propertyIdExampleIllustration: defaultData?.imageInfo?.propertyIdExampleIllustration,
        imageAltText: defaultData?.imageInfo?.imageAltText
      }
    };
  };
  static getImageCDNPath = (fileName: string) =>
    `${resolveCDNDir()}images/${fileName}`;

  static getEnonicContent = async (dataUrl: string) => {
    const response: any = await apiFetcher.postJson(dataUrl);
    let enonicData = {};
    if (response.isOk()) {
      if (response.value) {
        enonicData = response.value;
      }
    }
    return enonicData;
  };
}
